import { render, staticRenderFns } from "./SurveyHeader.vue?vue&type=template&id=6913cee4&"
import script from "./SurveyHeader.vue?vue&type=script&lang=ts&"
export * from "./SurveyHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports